// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************************************************************/
/* 全体基本設定 */
html	{
	font-size: 62.5%;
}
html, body	{
	margin: 0;
	padding: 0;
	border: 0;
	width: 100%;
	height: 100%;
}
#wrapper	{
	height: inherit;
	overflow: hidden;
	position: relative;
	font-size: 1.1rem;
}
#app	{
	margin: 0;
	padding: 0;
	height: inherit;
}

/******************************************************************************/
/* 操作パネル開けるボタン */
#open {
	position: absolute;
	top: 10px;
	left: 10px;
	width: 30px;
	height: 30px;
	z-index: 10;
	background-color: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 2px solid #555;
	border-radius: 5px;
	cursor: pointer;
	background-color: rgba(255,255,255,0.7);
}
#open:hover {
	background-color: rgba(255,255,255,1);
}

/******************************************************************************/
/* 操作パネル基本設定 */
#nav	{
	width: 205px;
	height: inherit;
	background-color: #fff;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 20;
	border-right: 1px solid #555;
	color: #000;
}
#nav.hide	{
	display: none;
}

/******************************************************************************/
/* 操作パネルヘッダ部 */
#nav div.header	{
	position: relative;
}
#nav div.header h1	{
	font-size: 1.2rem;
	margin: 0;
	padding: 5px;
}
#nav div.header span	{
	position: absolute;
	top: 3px;
	right: 3px;
	border: 2px solid #555;
	border-radius: 5px;
	font-size: 1.2rem;
	cursor: pointer;
}

/******************************************************************************/
/* 操作パネル各部 */
#nav dl	{
	margin: 0;
}
#nav dl dt,
#nav dl dd	{
	margin: 0;
	padding: 3px 5px;
}
#nav dl dt	{
	border-top: 1px solid #000;
	border-bottom: 1px solid #000;
	background-color: #ddd;
	font-weight: bold;
}

/******************************************************************************/
/* 操作パネル操作要素共通設定 */
#nav dl dd.measurement,
#nav dl dd.color,
#nav dl dd.basemap	{
	display: flex;
}
#nav dl dd span	{
	margin-right: 3px;
	display: inline-block;
	box-sizing: border-box;
	width: 28px;
	height: 28px;
}
#nav dl dd span.btn	{
	border: 2px solid #999;
	border-radius: 5px;
	cursor: pointer;
	text-align: center;
}

/******************************************************************************/
/* 操作パネル　測定モード */
#nav dl dd.measurement span.btn:last-child	{
	margin-left:auto;
	margin-right: 0;
	border: 0;
}
#nav dl dd.measurement span.btn.measurement.on	{
	background-color: #f00;
}

/******************************************************************************/
/* 操作パネル配色グラデーション */
#nav dl dd.color span.btn.gradation	{
	background: linear-gradient(
		0deg,
		#44f,
		#4f4 50%,
		#f44
	);
}

/******************************************************************************/
/* 操作パネル視点位置 */
#nav dl dd.camera span.btn	{
	line-height: 28px;
	font-weight: bold;
}

/******************************************************************************/
/* 操作パネル背景設定 */
/* #nav dl dd.background span.btn.black	{
	background-color: #000;
}
#nav dl dd.background span.btn.white	{
	background-color: #fff;
}
#nav dl dd.background span.btn.blue	{
	background-color: #00f;
}
#nav dl dd.background span.btn.sky	{
	background-color: #5dd;
	color: #fff;
}
#nav dl dd.background span.btn.night	{
	background-color: #003;
	color: #fff;
} */
`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E,WAAW;AACX;CACC,gBAAgB;AACjB;AACA;CACC,SAAS;CACT,UAAU;CACV,SAAS;CACT,WAAW;CACX,YAAY;AACb;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;AAClB;AACA;CACC,SAAS;CACT,UAAU;CACV,eAAe;AAChB;;AAEA,+EAA+E;AAC/E,gBAAgB;AAChB;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,WAAW;CACX,YAAY;CACZ,WAAW;CACX,sBAAsB;CACtB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf,uCAAuC;AACxC;AACA;CACC,qCAAqC;AACtC;;AAEA,+EAA+E;AAC/E,cAAc;AACd;CACC,YAAY;CACZ,eAAe;CACf,sBAAsB;CACtB,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,4BAA4B;CAC5B,WAAW;AACZ;AACA;CACC,aAAa;AACd;;AAEA,+EAA+E;AAC/E,cAAc;AACd;CACC,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,SAAS;CACT,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,sBAAsB;CACtB,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;AAChB;;AAEA,+EAA+E;AAC/E,YAAY;AACZ;CACC,SAAS;AACV;AACA;;CAEC,SAAS;CACT,gBAAgB;AACjB;AACA;CACC,0BAA0B;CAC1B,6BAA6B;CAC7B,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA,+EAA+E;AAC/E,kBAAkB;AAClB;;;CAGC,aAAa;AACd;AACA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,WAAW;CACX,YAAY;AACb;AACA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;;AAEA,+EAA+E;AAC/E,gBAAgB;AAChB;CACC,gBAAgB;CAChB,eAAe;CACf,SAAS;AACV;AACA;CACC,sBAAsB;AACvB;;AAEA,+EAA+E;AAC/E,mBAAmB;AACnB;CACC;;;;;EAKC;AACF;;AAEA,+EAA+E;AAC/E,cAAc;AACd;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA,+EAA+E;AAC/E,cAAc;AACd;;;;;;;;;;;;;;;;GAgBG","sourcesContent":["/******************************************************************************/\n/* 全体基本設定 */\nhtml\t{\n\tfont-size: 62.5%;\n}\nhtml, body\t{\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n#wrapper\t{\n\theight: inherit;\n\toverflow: hidden;\n\tposition: relative;\n\tfont-size: 1.1rem;\n}\n#app\t{\n\tmargin: 0;\n\tpadding: 0;\n\theight: inherit;\n}\n\n/******************************************************************************/\n/* 操作パネル開けるボタン */\n#open {\n\tposition: absolute;\n\ttop: 10px;\n\tleft: 10px;\n\twidth: 30px;\n\theight: 30px;\n\tz-index: 10;\n\tbackground-color: #fff;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder: 2px solid #555;\n\tborder-radius: 5px;\n\tcursor: pointer;\n\tbackground-color: rgba(255,255,255,0.7);\n}\n#open:hover {\n\tbackground-color: rgba(255,255,255,1);\n}\n\n/******************************************************************************/\n/* 操作パネル基本設定 */\n#nav\t{\n\twidth: 205px;\n\theight: inherit;\n\tbackground-color: #fff;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 20;\n\tborder-right: 1px solid #555;\n\tcolor: #000;\n}\n#nav.hide\t{\n\tdisplay: none;\n}\n\n/******************************************************************************/\n/* 操作パネルヘッダ部 */\n#nav div.header\t{\n\tposition: relative;\n}\n#nav div.header h1\t{\n\tfont-size: 1.2rem;\n\tmargin: 0;\n\tpadding: 5px;\n}\n#nav div.header span\t{\n\tposition: absolute;\n\ttop: 3px;\n\tright: 3px;\n\tborder: 2px solid #555;\n\tborder-radius: 5px;\n\tfont-size: 1.2rem;\n\tcursor: pointer;\n}\n\n/******************************************************************************/\n/* 操作パネル各部 */\n#nav dl\t{\n\tmargin: 0;\n}\n#nav dl dt,\n#nav dl dd\t{\n\tmargin: 0;\n\tpadding: 3px 5px;\n}\n#nav dl dt\t{\n\tborder-top: 1px solid #000;\n\tborder-bottom: 1px solid #000;\n\tbackground-color: #ddd;\n\tfont-weight: bold;\n}\n\n/******************************************************************************/\n/* 操作パネル操作要素共通設定 */\n#nav dl dd.measurement,\n#nav dl dd.color,\n#nav dl dd.basemap\t{\n\tdisplay: flex;\n}\n#nav dl dd span\t{\n\tmargin-right: 3px;\n\tdisplay: inline-block;\n\tbox-sizing: border-box;\n\twidth: 28px;\n\theight: 28px;\n}\n#nav dl dd span.btn\t{\n\tborder: 2px solid #999;\n\tborder-radius: 5px;\n\tcursor: pointer;\n\ttext-align: center;\n}\n\n/******************************************************************************/\n/* 操作パネル　測定モード */\n#nav dl dd.measurement span.btn:last-child\t{\n\tmargin-left:auto;\n\tmargin-right: 0;\n\tborder: 0;\n}\n#nav dl dd.measurement span.btn.measurement.on\t{\n\tbackground-color: #f00;\n}\n\n/******************************************************************************/\n/* 操作パネル配色グラデーション */\n#nav dl dd.color span.btn.gradation\t{\n\tbackground: linear-gradient(\n\t\t0deg,\n\t\t#44f,\n\t\t#4f4 50%,\n\t\t#f44\n\t);\n}\n\n/******************************************************************************/\n/* 操作パネル視点位置 */\n#nav dl dd.camera span.btn\t{\n\tline-height: 28px;\n\tfont-weight: bold;\n}\n\n/******************************************************************************/\n/* 操作パネル背景設定 */\n/* #nav dl dd.background span.btn.black\t{\n\tbackground-color: #000;\n}\n#nav dl dd.background span.btn.white\t{\n\tbackground-color: #fff;\n}\n#nav dl dd.background span.btn.blue\t{\n\tbackground-color: #00f;\n}\n#nav dl dd.background span.btn.sky\t{\n\tbackground-color: #5dd;\n\tcolor: #fff;\n}\n#nav dl dd.background span.btn.night\t{\n\tbackground-color: #003;\n\tcolor: #fff;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
